<template>
  <div
    v-if="waitingForStoreRocket"
    :class="bem('loading')"
  >
    <p>Loading Store Locator...</p>
  </div>

  <div :class="bem('container')" />
</template>



<script setup>
useHead({
  script: [
    {
      src: 'https://cdn.storerocket.io/widget.js',
      async: true,
      defer: true
    }
  ]
})

const props = defineProps({
  block: {
    type: Object,
    required: true
  }
})

const waitingForStoreRocket = ref(true)
const interval = ref(null)

const bem = useBEM('StoreLocator')

onMounted(() => {
  interval.value = setInterval(() => {
    if (typeof window.StoreRocket !== 'undefined') {
      clearInterval(interval.value)
      waitingForStoreRocket.value = false

      StoreRocket.init({
        selector: `.${bem('container')}`,
        account: "9X8Rq35JAE",
        location: props.block?.locationSlug
      })
    }
  }, 100)
})

onUnmounted(() => {
  clearInterval(interval.value)
})
</script>

<style lang="postcss">
.StoreLocator__container {
  @apply w-full;

  #storerocket-panel,
  #storerocket-map-container {
    z-index: 11;
  }
}
</style>